export default __webpack_public_path__ + "static/media/gb-nir.6da6aac9.svg";